import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { Steps } from '../Steps';
import { BrandTitles } from './BrandTitles';
import React from 'react';

export const BrandTitlesVw: BrandTitles = {
  [Steps.Bookings]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Your <Text bold>bookings</Text>
    </Text>
  ),
  [Steps.Identification]: <></>,
  [Steps.YourVehicle]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Your <Text bold>vehicle</Text>
    </Text>
  ),
  [Steps.SelectService]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Your <Text bold>service</Text>
    </Text>
  ),
  [Steps.SelectDealer]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Select <Text bold>dealer</Text>
    </Text>
  ),
  [Steps.EstimatedPrice]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Your <Text bold>estimated price</Text>
    </Text>
  ),
  [Steps.Appointment]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Select <Text bold>your preferred appointment date</Text>
    </Text>
  ),
  [Steps.CollectionAndDelivery]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Your <Text bold> collection and delivery</Text>
    </Text>
  ),
  [Steps.ContactDetails]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Your <Text bold>contact details</Text>
    </Text>
  ),
  [Steps.ReviewAndSubmit]: (
    <Text appearance={TokenTextAppearance.headline300}>
      Your <Text bold>review and submit</Text>
    </Text>
  ),
};
